import { ProfileViewResponse } from "@/generated-api";
import { FavoriteButton } from "./FavoriteButton";

import NameAndLastSeen from "./NameAndLastSeen";
import NationalityLocation from "./NationalityLocation";
import GeneralSection from "./GeneralSection";
import LanguagesSection from "./LanguagesSection";
import JoinedAtBadge from "./JoinedAtBadge";
import MessageButton from "./MessageButton";
import MessageBottomBar from "./MessageBottomBar";

export function ProfileViewDetails({
  userId,
  profileView,
  isSelfView = false,
}: {
  userId: string;
  profileView: ProfileViewResponse;
  isSelfView?: boolean;
}) {
  return (
    <>
      <div className="h-fit md:bg-zinc-900 flex flex-col gap-y-6 rounded-lg mb-2 pt-0 md:pt-4 p-4 select-none">
        <NameAndLastSeen profileView={profileView} />
        <NationalityLocation profileView={profileView} />
        <div className="hidden md:flex flex-row items-center">
          <MessageButton
            profileView={profileView}
            userId={userId}
            isSelfView={isSelfView}
          />
          <FavoriteButton
            active={profileView.is_favorite}
            userId={userId}
            disabled={isSelfView}
          />
        </div>
        {profileView.bio && (
          <div className="select-text w-full text-wrap break-words whitespace-pre-wrap">
            {profileView.bio}
          </div>
        )}
        <GeneralSection profileView={profileView} />
        <LanguagesSection languages={profileView.languages} />
        <JoinedAtBadge joinedAt={profileView.joined_at} />
      </div>
      {!isSelfView && (
        <MessageBottomBar
          userId={userId}
          profileView={profileView}
          isSelfView={isSelfView}
        />
      )}
    </>
  );
}
